import type { DealType } from "~/models/Deal";

export type DealInfo = {
	dealType: Extract<DealType, "repair" | "restoration"> | null;
	leasingId: string | null;
};

const availableDealType = (
	dealTypeQuery: string | null
): Extract<DealType, "repair" | "restoration"> | null => {
	// KTからNSKに遷移する際に、dealType= repair or restorationでしか遷移しないため
	if (dealTypeQuery === "repair" || dealTypeQuery === "restoration") {
		return dealTypeQuery;
	}
	return null;
};

export const getDealInfoFromUrlSearchParams = (
	urlSearchParams: URLSearchParams
): DealInfo => ({
	dealType: availableDealType(urlSearchParams.get("deal_type")),
	leasingId: urlSearchParams.get("leasing_id")
});
